/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_CalendarFeedDto } from '../models/Routemize_DTOs_CalendarFeedDto';
import type { Routemize_DTOs_CreateCalendarFeedDto } from '../models/Routemize_DTOs_CreateCalendarFeedDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CalendarFeedService {
    /**
     * @param token
     * @returns any OK
     * @throws ApiError
     */
    public static getApiCalendarFeedIcs(
        token: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/calendar-feed/{token}.ics',
            path: {
                'token': token,
            },
        });
    }
    /**
     * @param token
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAppCalendarFeedFeedIcs(
        token?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/calendarFeed/feedIcs',
            query: {
                'token': token,
            },
        });
    }
    /**
     * @returns Routemize_DTOs_CalendarFeedDto OK
     * @throws ApiError
     */
    public static getApiAppCalendarFeedGetMyFeed(): CancelablePromise<Routemize_DTOs_CalendarFeedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/calendarFeed/getMyFeed',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_CalendarFeedDto OK
     * @throws ApiError
     */
    public static postApiAppCalendarFeedGenerateFeed(
        requestBody?: Routemize_DTOs_CreateCalendarFeedDto,
    ): CancelablePromise<Routemize_DTOs_CalendarFeedDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/calendarFeed/generateFeed',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppCalendarFeedRevokeFeed(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/calendarFeed/revokeFeed',
        });
    }
}
